import { FILTER_TYPES } from 'components/FilterPod';

const filters = () => [
  {
    title: 'وضعیت درخواست',
    label: 'وضعیت درخواست',
    keyName: 'status',
    query: 'status',
    id: 1649,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: [
        {
          value: 'PENDING',
          label: "در انتظار ثبت درخواست",
        },
        {
          value: 'PENDING_TO_CONFIRM',
          label: "در انتظار تایید بانک",
        },
        {
          value: 'CONFIRMED',
          label: "تایید شده",
        },
        {
          value: 'REJECTED',
          label: "رد شده",
        },
      ],
    },
  },
];

export default filters;
